import React, { createContext, useContext, useState, useCallback, useEffect, useRef } from 'react';
import { findingsAPI } from '../services/api';
import { useAuth } from './AuthContext';

const FindingsContext = createContext(null);

export const FindingsProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [unseenCount, setUnseenCount] = useState(0);
  const pollRef = useRef(null);

  const refreshUnseenCount = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const res = await findingsAPI.unseenCount();
      setUnseenCount(res.data.unseen_count || 0);
    } catch (_) {
      // Silently ignore — badge is non-critical
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      setUnseenCount(0);
      return;
    }
    refreshUnseenCount();
    pollRef.current = setInterval(refreshUnseenCount, 30000);
    return () => clearInterval(pollRef.current);
  }, [isAuthenticated, refreshUnseenCount]);

  return (
    <FindingsContext.Provider value={{ unseenCount, refreshUnseenCount }}>
      {children}
    </FindingsContext.Provider>
  );
};

export const useFindings = () => {
  const ctx = useContext(FindingsContext);
  if (!ctx) throw new Error('useFindings must be used within FindingsProvider');
  return ctx;
};
